import { runtime } from '../utils/runtime';

export function isGameMap3dAvailable(source = runtime) {
  const runtimeValue = source?.pfandpirat3dMapEnabled ?? source?.pfandpirat_3d_map_enabled;
  if (runtimeValue === true || runtimeValue === 1 || runtimeValue === '1') return true;
  return false;
}

export const isGameMap3dEnabled = isGameMap3dAvailable;
